import { LoaderFunctionArgs } from "@remix-run/node";
import { typedjson } from "remix-typedjson";
import { BarberSelect } from "~/components/booking/BarberSelect";
import { CalendarInput } from "~/components/booking/CalendarInput";
import { BookingFormContextProvider } from "~/components/booking/ContextProvider";
import { DepositAlert } from "~/components/booking/DepositAlert";
import { LocationSelect } from "~/components/booking/LocationSelect";
import { NameInput } from "~/components/booking/NameInput";
import { PhoneInput } from "~/components/booking/PhoneInput";
import { ServiceSelect } from "~/components/booking/ServiceSelect";
import { StripePayment } from "~/components/booking/StripePayment";
import { TimeSelectInput } from "~/components/booking/TimeSelectInput";
import { TotalPrice } from "~/components/booking/TotalPrice";
import { Logo } from "~/components/logo";
import { Card, CardContent } from "~/components/ui/card";
import { prisma } from "~/utils/db.server";
import { useLiveLoaderData } from "~/utils/hooks/use-live-loader";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  return typedjson({
    locations: await prisma.location.findMany({
      select: {
        id: true,
        name: true,
        color: true,
      },
      where: {
        hidden: false,
      },
    }),
    url: request.url,
  });
};

export default function Booking() {
  let { locations, url } = useLiveLoaderData<typeof loader>();

  return (
    <>
      <header className="p-4">
        <Logo className="mx-auto h-20 w-20" />
      </header>

      <main className="mx-auto mb-6 max-w-3xl">
        <BookingFormContextProvider>
          <Card className="h-full w-full pb-8">
            <CardContent className="p-0 py-6">
              <div className="space-y-4" id="booking-form">
                <LocationSelect locations={locations} />

                <div className="h-px bg-white/5" />

                <BarberSelect />

                <div className="h-px bg-white/5" />

                <ServiceSelect />

                <div className="h-px bg-white/5" />

                <CalendarInput />

                <div className="h-px bg-white/5" />

                <TimeSelectInput />

                <div className="h-px bg-white/5" />

                <NameInput />

                <PhoneInput />

                <div className="h-px bg-white/5" />

                <TotalPrice />

                <div className="h-px bg-white/5" />

                <DepositAlert />

                <StripePayment url={new URL(url)} />
              </div>
            </CardContent>
          </Card>
        </BookingFormContextProvider>
      </main>
    </>
  );
}
